export enum AgoraProduct {
  Insights = 'insights',
  Intelligence = 'intelligence'
}

export interface ProductLogo {
  readonly url: string;
  readonly text: string;
}

export interface ProductBranding {
  readonly product: AgoraProduct;
  readonly title: string;
  readonly logo: ProductLogo;
}

export const DEFAULT_PRODUCT = AgoraProduct.Insights;

export const PRODUCT_BRANDINGS: Readonly<Record<AgoraProduct, ProductBranding>> = {
  [AgoraProduct.Insights]: {
    product: AgoraProduct.Insights,
    title: 'MRI Agora Insights',
    logo: { url: 'assets/images/agora_insights_nav_logo.svg', text: 'Agora Insights' }
  },
  [AgoraProduct.Intelligence]: {
    product: AgoraProduct.Intelligence,
    title: 'MRI Agora Intelligence',
    logo: { url: 'assets/images/agora_intelligence_nav_logo.svg', text: 'Agora Intelligence' }
  }
};

const HOST_PATTERNS: ReadonlyArray<readonly [AgoraProduct, RegExp]> = [
  [AgoraProduct.Intelligence, /agora-?intelligence/i],
  [AgoraProduct.Insights, /agora-?insights/i]
];

export function productForHostname(hostname: string): AgoraProduct {
  return HOST_PATTERNS.find(([, pattern]) => pattern.test(hostname))?.[0] ?? DEFAULT_PRODUCT;
}

export function brandingForHostname(hostname: string): ProductBranding {
  return PRODUCT_BRANDINGS[productForHostname(hostname)];
}
